import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { isNewbuildingFromBuilderSelector, isNewbuildingFromSellerSelector } from 'shared/selectors';
import { selectIsChatsEnabled } from 'shared/selectors/offerChat';

import { ChatOnboardingContainer } from '../../ChatOnboardingContainer';
import { SendMessageButtonContainer } from '../SendMessageButton';

interface INewbuildingMessageButtonContainerProps {
  isPhonesOpened: boolean;
}

const PLACE_TYPE = 'Open_card_floating_block';

export const NewbuildingMessageButtonContainer: React.FC<INewbuildingMessageButtonContainerProps> = ({
  isPhonesOpened,
}) => {
  const isChatsEnabled = useSelector(selectIsChatsEnabled);
  const isNewbuildingFromBuilder = useSelector(isNewbuildingFromBuilderSelector);
  const isNewbuildingFromSeller = useSelector(isNewbuildingFromSellerSelector);

  const isNewbuildingFromDeveloper = isNewbuildingFromBuilder || isNewbuildingFromSeller;

  if (!isChatsEnabled || !isNewbuildingFromDeveloper) {
    return null;
  }

  if (isPhonesOpened) {
    return (
      <SendMessageButtonContainer title="Написать в чат" theme="fill_primary" noMarginTop placeType={PLACE_TYPE} />
    );
  }

  return (
    <ChatOnboardingContainer type="builder" placement="top-end" minWidth="160px">
      <SendMessageButtonContainer
        title={null}
        theme="fill_primary"
        ariaLabel="Написать застройщику"
        beforeIcon={<IconCommunicationMessage16 color="icon-inverted-default" />}
        noMarginTop
        placeType={PLACE_TYPE}
      />
    </ChatOnboardingContainer>
  );
};
